// components/RazorpayButton.js

import React from "react";
import Swal from "sweetalert2";

const RazorpayButton = ({ amount }) => {
  
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const loadRazorpay = async () => {
    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      //alert("Razorpay SDK failed to load. Are you online?");
      Swal.fire({
      icon: "error",
      title: "Failed", 
      text: "Razorpay SDK failed to load. Are you online?",
      cancelButtonColor: "#e83333",
      cancelButtonText: "Cancel",
    });
      return;
    }

    try {
      const accessToken = localStorage.getItem("access_token");

      // 1. Create order via backend
      const res = await fetch("http://localhost:8000/api/create-order/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ amount }),
      });

      if (!res.ok) {
        throw new Error("Failed to create Razorpay order");
      }

      const data = await res.json();

      if (!data.razorpay_key || !data.order_id) {
       // alert("Invalid order details received from server.");
        Swal.fire({
          icon: "error",
          title: "Failed", 
          text: "Invalid order details received from server.",
          cancelButtonColor: "#e83333",
          cancelButtonText: "Cancel",
        });
        return;
      }

      // 2. Configure Razorpay
      const options = {
        key: data.razorpay_key,
        amount: data.amount,
        currency: data.currency,
        name: "My Shop",
        description: "Test Transaction",
        order_id: data.order_id,
        handler: async function (response) {
          try {
            const verifyRes = await fetch("http://localhost:8000/api/verify-payment/", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify(response),
            });

            const verifyData = await verifyRes.json();

            if (verifyRes.ok) {
             // alert("Payment successful and verified!");
               Swal.fire({
                  icon: "success",
                  title: "Payment successful!",
                  text: "Payment successful and verified!",
                  confirmButtonText: "Ok",
                });
            } else {
              console.error("Verification failed:", verifyData);
             // alert("Payment verification failed.");
              Swal.fire({
                icon: "error",
                title: "Failed", 
                text: "Payment verification failed.",
                cancelButtonColor: "#e83333",
                cancelButtonText: "Cancel",
              });
            }
          } catch (error) {
            console.error("Verification error:", error);
           // alert("Payment verification error.");
            Swal.fire({
              icon: "error",
              title: "Error", 
              text: "Payment verification error.",
              cancelButtonColor: "#e83333",
              cancelButtonText: "Cancel",
            });
          }
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment error:", error);
     // alert("Something went wrong while processing the payment.");
      Swal.fire({
        icon: "error",
        title: "Wrong!", 
        text: "Something went wrong while processing the payment.",
        cancelButtonColor: "#e83333",
        cancelButtonText: "Cancel",
      });
        }
      };

  return (
    <button
      onClick={loadRazorpay}
      style={{
        padding: "10px 20px",
        background: "#1A73E8",
        color: "white",
        border: "none",
        borderRadius: "5px",
      }}
    >
      Pay ₹{amount}
    </button>
  );
};

export default RazorpayButton;
